// extracted by mini-css-extract-plugin
export default {"productDescription":"Daa-z","featuredDescription":"Eaa-z","description":"Faa-z","more":"Gaa-z","descriptionSku":"Haa-z"};